import {AfterViewInit, Component, OnInit} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';

@Component({
  selector: 'app-main-menu',
  templateUrl: './main-menu.component.html',
  styleUrls: [
    '../../../assets/vendor/mdi-font/css/material-design-iconic-font.min.css',
    '../../../assets/Content/src/css/lib.vendor.css',
    '../../../assets/Content/src/css/lib.picker.css',
    '../../../assets/vendor/font-awesome-4.7/css/font-awesome.min.css',
    '../../../assets/css/light.theme.css'
  ]
})
export class MainMenuComponent implements OnInit, AfterViewInit {
  productName: string;

  constructor(private router: Router, private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {
    this.activatedRoute.params.subscribe((params: Params) => {
      console.log(params.productName);
      this.productName = params.productName;
    });
  }

  create() {
    this.router.navigate([`/insurance-service/${this.productName}/basic-information`]);
  }
}
